import React from 'react';

// eslint-disable-next-line max-len
const AGENT99_LOGO = '/themes/theme/agent99/logo.png';

const AGENT99Theme = {
  headerLogo: {
    src: AGENT99_LOGO,
    alt: 'AGENT99 Logo',
    size: 70,
  },
  darkLogo: {
    src: AGENT99_LOGO,
    alt: 'AGENT99 Logo',
    size: 70,
  },
  linkStyle: {
    color: '#c9378d',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #000',
    height: 80,
  },
  title: 'Agent99',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="150"
        src={AGENT99_LOGO} alt="AGENT99 Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://agent99r.dyzio.co',
  isFullWhiteLabel: true,
};

export default AGENT99Theme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/agent99.js
 **/